//imgs
import Icon1 from "../../../assets/imgs/consultancy-solution/icon1.png";
import Icon2 from "../../../assets/imgs/consultancy-solution/icon2.png";
import Icon3 from "../../../assets/imgs/consultancy-solution/icon3.png";
import Icon4 from "../../../assets/imgs/consultancy-solution/icon4.png";
import Icon5 from "../../../assets/imgs/consultancy-solution/icon5.png";
import Icon5_1 from "../../../assets/imgs/consultancy-solution/icon5_1.png";
import Icon5_2 from "../../../assets/imgs/consultancy-solution/icon5_2.png";
import Icon6 from "../../../assets/imgs/consultancy-solution/icon6.png";

export const OPPORTUNITIES_DATA = [
  {
    heading1: "Healthcare",
    // heading2: 'Living',
    IconImg: Icon1,
    details: [
      { txt: "Nursing" },
      { txt: "Medical Assistance" },
      { txt: "Physiotherapy" },
    ],
  },
  {
    heading1: "Engineering",
    // heading2: 'Courses',
    IconImg: Icon2,
    details: [
      { txt: "Mechanical" },
      { txt: "Electrical" },
      { txt: "Civil Engineering" },
    ],
  },
  {
    heading1: "Business Administration",
    // heading2: '',
    IconImg: Icon3,
    details: [
      { txt: "Marketing" },
      { txt: "Finance" },
      { txt: "Human Resources" },
    ],
  },
  {
    heading1: "Information Technology",
    // heading2: '',
    IconImg: Icon4,
    details: [
      { txt: "Software Development" },
      { txt: "IT Support" },
      { txt: "Network Administration" },
    ],
  },
  {
    heading1: "Hospitality And Tourism",
    // heading2: '',
    IconImg: Icon5,
    IconImg1: Icon5_1,
    IconImg2: Icon5_2,
    details: [
      { txt: "Hotel Management" },
      { txt: "Culinary Arts" },
      { txt: "Travel Services" },
    ],
  },
  {
    heading1: "Retail And Sales",
    // heading2: '',
    IconImg: Icon6,
    details: [{ txt: "Store Management" }, { txt: "Marketing" }],
  },
];
